import React from "react";
import './Switch.scss';

type SwitchProps = {
    className?: string,
    label: string,
    checked?: boolean,
    onChange: (checked: boolean) => void,
};

function Switch(props: SwitchProps) {

    return (
        <div className={`switch-container ${props.className}`}>
            <label className="switch">
                <input type="checkbox" checked={props.checked} onChange={(e: React.ChangeEvent<HTMLInputElement>) => props.onChange(e.target.checked)}/>
                <span className="slider round"></span>
            </label>
            <span className="switch-label">{props.label}</span>
        </div>
    );
}

export default Switch;
